import React from 'react';
import PropTypes from 'prop-types';

const Warning = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <rect id="bound" width="24" height="24" fill="none" />
      <path id="Path-117" d="M11.167,4.5,2.825,19.514A1,1,0,0,0,3.7,21H21.217a1,1,0,0,0,.853-1.521L12.894,4.464a1,1,0,0,0-1.727.036Z" transform="translate(0 -1.505)" fill={color} fillRule="evenodd" opacity="0.3" />
      <rect id="Rectangle-9" width="2" height="7" rx="1" transform="translate(11 7.495)" fill={color} />
      <rect id="Rectangle-9-Copy" width="2" height="2" rx="1" transform="translate(11 16)" fill={color} />
    </svg>
  );
}

Warning.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Warning.defaultProps = {
  color: '#FFFFFF',
  width: 20,
  height: 20,
};

export default Warning;



// WEBPACK FOOTER //
// ./src/components/Icons/Warning.jsx